<template>
  <!--  :route-to="routeTo"-->
  <gj-link
      @click="routeClick">
    <slot></slot>
  </gj-link>
</template>

<script>
  import {adStore} from "../../../common/store";

  export default {
    name: "app-sb-ad-route-link",
    props: {
      adManager: {
        type: Object,
        default: null
      },
      adCampaignManager: {
        type: Object,
        default: null
      },
      adGroupManager: {
        type: Object,
        default: null
      }
    },
    methods: {
      routeClick() {
        if (this.adManager) {
          adStore.SB.campaign = null;
          adStore.SB.group = null;
        } else if (this.adCampaignManager) {
          adStore.SB.campaign = this.adCampaignManager.campaign;
          adStore.SB.campaignDate = this.adCampaignManager.date;
          adStore.SB.group = null;
        } else if (this.adGroupManager) {
          adStore.SB.campaign = this.adGroupManager.campaign;
          adStore.SB.group = this.adGroupManager.group;
          adStore.SB.campaignDate = this.adGroupManager.date;
          adStore.SB.groupDate = this.adGroupManager.date;
        }
        this.$emit("routeClick")
      }
    }
  }
</script>

<style scoped>

</style>
